module.exports = __webpack_public_path__ + "img/small2.e01c35de.jpg";